import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../constants';

export const PlotContainer = styled.div`
  background-color: ${({ theme }) => theme.customTheme.primary};
  color: ${({ theme }) => theme.contrast.tertiary};

  width: 18rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 5rem;
  /* justify-content: space-between; */
  border-radius: 1rem;
  position: relative;
  &.content::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    box-shadow: 0px 5px 19px ${({ theme }) => theme.core.secondary};
    z-index: 12;
  }
`;

export const PlotBtn = styled.div`
  font-size: ${fontSize.titleBig};
  font-family: ${fontFamily.circularMedium};
  padding: 10px 0px;
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
  width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${({ theme }) => theme.contrast.tertiary};
  text-align: center;
  background-color: ${({ theme }) => theme.customTheme.primary};
  position: relative;
  z-index: 15;
`;

export const ItemsNo = styled.span`
  background-color: ${({ theme }) => theme.contrast.tertiary};
  border-radius: 8px;
  width: ${fontSize.title};
  color: black;
  font-size: ${fontSize.title};
  position: absolute;
  top: -10px;
  right: 10px;
`;

export const PlotOptions = styled.div`
  padding: 1.8rem;
  z-index: 15;
  background-color: ${({ theme }) => theme.customTheme.primary};
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
`;

export const DropdownImage = styled.img`
  height: 1.2rem;
  transform: rotate(90deg);
  &.active {
    transform: rotate(270deg);
  }
`;

export const PlotDropDownContainer = styled.div`
  position: absolute;
  /* top: 4.8rem; */
  bottom: 4rem;
  padding-top: 2.5rem;
  background-color: ${({ theme }) => theme.customTheme.primary};
  z-index: 10;
  width: 100%;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
`;

export const PlotOptionText = styled.div`
  font-size: ${fontSize.titleBig};
  padding-left: 10px;
  padding-bottom: 10px;
  font-family: ${fontFamily.circularMedium};
  text-transform: capitalize;
  color: white;
`;
